import * as React from 'react';

import { PromosBannerCallButton } from './PromosBannerCallButton';
import { PromosBanner as PromosBannerComponent } from '../../../components/NewbuildingPromos/parts/PromosBanner';

export const PromosBanner = () => {
  return <PromosBannerComponent CallButton={PromosBannerCallButton} />;
};
